var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65358 3.09566L13.9041 7.3464L4.67424 16.5767L0.884537 16.9951C0.377206 17.0512 -0.0514349 16.6222 0.0050089 16.1148L0.426678 12.3223L9.65358 3.09566ZM16.5331 2.4628L14.5373 0.466927C13.9148 -0.155642 12.9051 -0.155642 12.2825 0.466927L10.405 2.34459L14.6555 6.59533L16.5331 4.71766C17.1556 4.09476 17.1556 3.08537 16.5331 2.4628Z",
    fill: "#A8A8A8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e7d3d879.svg";
export { ForwardRef as ReactComponent };